// gtag 함수 정의
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

export function eeaDefaultData(liveSiteCookie) {
  if (!liveSiteCookie) {
    gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'granted',
      ad_personalization: 'denied',
      functionality_storage: 'denied',
      analytics_storage: 'denied',
    });
  }
}

// eeaCookies 함수 내에서 gtag 함수 사용
export function eeaCookies(data) {
  gtag('consent', 'update', data);
}
